module.exports = __webpack_public_path__ + "static/media/vedit.c28dd01e.svg";